import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const untappedMarkets = [
    {
        title: 'Sub-Saharan Africa',
        description: 'A growing pool of skilled AI and tech talent, driven by increased internet penetration and digital transformation.',
    },
    {
        title: 'Southeast Asia',
        description: 'Rapidly emerging tech hubs with strong government support for AI and digital innovation.',
    },
    {
        title: 'Latin America',
        description: 'A young, tech-savvy workforce with rising interest in AI, data science, and software development.',
    },
    {
        title: 'Middle East & North Africa (MENA)',
        description: 'A region investing heavily in AI, with universities producing top-tier talent in data science and cybersecurity.',
    },
    {
        title: 'Eastern Europe',
        description: 'Highly skilled developers and engineers with strong backgrounds in mathematics and computer science.',
    },
    {
        title: 'South Asia',
        description: 'A thriving tech ecosystem with increasing AI and machine learning adoption in various industries.',
    },
    {
        title: 'Caribbean & Pacific Islands',
        description: 'An emerging market with untapped potential for AI-driven solutions in finance, healthcare, and logistics.',
    },
    {
        title: 'Rural Innovation Hubs',
        description: 'Decentralized tech hubs fostering AI and software development talent outside major cities.',
    },
];

function UntappedTalentMarkets() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>Untapped Talent Markets</Title>
                <Paragraph>
                    The global demand for AI and tech talent is growing, and many emerging regions are becoming key players in the industry. 
                    JectHub is committed to identifying and supporting these untapped talent markets, fostering innovation and inclusivity in AI.
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {untappedMarkets.slice(0, 4).map((market, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={market.title} bordered={false}>
                                <Paragraph>{market.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <hr style={{ margin: '40px 0' }} />
                <Row gutter={[16, 16]}>
                    {untappedMarkets.slice(4, 8).map((market, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={market.title} bordered={false}>
                                <Paragraph>{market.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default UntappedTalentMarkets;
